// Whether the browser can reach us (spec C7, Offline): the browser's online and offline events,
// plus a check of /health when the person presses Try again. Save buttons read useOnline().
import { useSyncExternalStore } from 'react';

// Only a browser that says it is offline counts as offline (Node's navigator has no onLine).
let online = typeof navigator === 'undefined' || navigator.onLine !== false;
const listeners = new Set<() => void>();

function set(next: boolean) {
  if (next === online) return;
  online = next;
  for (const l of listeners) l();
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => set(true));
  window.addEventListener('offline', () => set(false));
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** True while the portal can save. */
export const useOnline = () =>
  useSyncExternalStore(
    subscribe,
    () => online,
    () => online,
  );

/** Try again on the Offline bar: true when the server answers. */
export async function checkOnline(fetchFn: typeof fetch = fetch): Promise<boolean> {
  try {
    const res = await fetchFn('/health', { cache: 'no-store' });
    set(res.ok);
    return res.ok;
  } catch {
    set(false);
    return false;
  }
}

/** For tests: start offline or online. */
export const setOnlineForTest = set;
